export default __webpack_public_path__ + "static/heavy-header-af75bf465325e36fa1d5fd18a2807af6.jpg";